import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { IconSize } from '@predictiveindex/tapestry';
import { Subject, takeUntil } from 'rxjs';
import { AvatarsAvailable, AvatarURLAndSource } from '../../../core-data-model';
import { AvatarService } from '../../../core-services/avatar-service';

@Component({
    selector: 'edit-avatar',
    templateUrl: './edit-avatar.component.html',
    styleUrls: ['./edit-avatar.component.less'],
    standalone: false
})
export class EditAvatarComponent implements OnInit, OnDestroy {
    @Output() avatarUrlChanged = new EventEmitter<string>();
    // Available avatar options
    avatarOptions: AvatarURLAndSource[] = [];
    currentlySelected = '';
    IconSize = IconSize;

    private destroyed$ = new Subject<void>();

    constructor(private avatarService: AvatarService) {}

    ngOnInit() {
        this.getMyAvatar();
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    getMyAvatar() {
        this.avatarService
            .getOwnAvailableAvatars()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((avatars) => {
                this.setCurrentAvatar(avatars);
            });
    }

    setCurrentAvatar(avatar: AvatarsAvailable) {
        this.avatarOptions = avatar.avatars;
        this.currentlySelected = avatar.selectedAvatarUrl;
        this.avatarUrlChanged.emit(this.currentlySelected);
    }

    getAvatarClass(url: string) {
        return url === this.currentlySelected
            ? 'edit-avatar-constraints selected-avatar'
            : 'edit-avatar-constraints';
    }

    changeSelected(source: string) {
        this.currentlySelected = source;
        this.avatarUrlChanged.emit(this.currentlySelected);
    }

    launchGravatar() {
        window.open('https://en.gravatar.com/', '_blank', 'noopener');
    }
}
